import styled, { css } from 'styled-components';
import { screen } from '@styles/mixins/breakpoints';
import { Link } from 'gatsby';
import { colors } from '@styles/variables';

const StyledCloseButton = styled(Link)`
  display: flex;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border: none;
  margin-right: 32px;
  background-color: ${colors.colorWhite};
  border-radius: 30px;
  cursor: pointer;
  transform: translateY(-50%);
  transition: background-color 0.15s;

  &:hover {
    background-color: ${colors.colorMutedWhite};
  }

  &:focus {
    background-color: ${colors.colorMutedWhite};
    outline: none;
  }

  ${screen.l(css`
    width: 40px;
    height: 40px;
    padding: unset;
  `)}
`;

export default { StyledCloseButton };
